import { render } from "./AiComponent.vue?vue&type=template&id=63f9793c&scoped=true"
import script from "./AiComponent.vue?vue&type=script&lang=js"
export * from "./AiComponent.vue?vue&type=script&lang=js"

import "./AiComponent.vue?vue&type=style&index=0&id=63f9793c&scoped=true&lang=css"

import exportComponent from "/var/www/vhosts/localhost/html/miw-alpha/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63f9793c"]])

export default __exports__